angular.module 'zc.masterApi'

.factory 'MasterReportStats', ($q, Facade, MasterProject, reportStatsResponseTransformer) ->
  MasterReportStats =
    find: (params) ->
      $q (resolve) ->
        Facade.request "/master/report_stats/#{params.dimension}", {
          params:
            json: params
          transformResponse: reportStatsResponseTransformer
        }
        .then (res) =>
          resolve res.data.report_stats

    forCSV: (report_stats) ->
      $q (resolve, reject) ->
        MasterProject.all()
        .then (projects) ->
          statsByStatus = _.groupBy report_stats, "status"

          statsByApikey = _.groupBy statsByStatus[null], 'apikey'
          statsForCSV = {}

          for apikey, apikeyStats of statsByApikey
            project = _.find(projects, (p) -> p.apikey == apikey)
            continue if !project
            sortedStats = _.sortBy apikeyStats, 'start_at'
            apikeyStats = _.last sortedStats
            last_contribution_price = 0
            for stats in sortedStats
              date = moment(stats.start_at).format('YYYY/M/D')
              apikeyStats[date] = stats.contribution_price - last_contribution_price
              last_contribution_price = stats.contribution_price
            statsForCSV[apikey] = _.merge {}, project, apikeyStats
            statsForCSV[apikey].campaign_count = statsForCSV[apikey].campaign_ids.length

            MasterReportStats.calculateInvoiceAmountRate(statsForCSV[apikey])
            MasterReportStats.calculateGoalPercentage(statsForCSV[apikey], project)

          for apikey, stats of statsForCSV
            for status in ["trial", "contracted"]
              stats[status] = _.chain statsByStatus[status]
                .filter (d) -> d.apikey == apikey
                .sortBy 'start_at'
                .last()
                .value()

            MasterReportStats.calculateInvoiceAmountRate(stats[status]) if stats[status]
            MasterReportStats.calculateGoalPercentage(stats[status], project) if stats[status]

          resolve statsForCSV

    calculateInvoiceAmountRate: (report) ->
      return if !report
      if report.access_conversion_price is 0
        report.invoice_amount_rate = 0
      else
        report.invoice_amount_rate =
          report.invoice_amount / report.access_conversion_price

    calculateGoalPercentage: (report, project) ->
      # Calculate how much of the goal has been achieved.
      if project.project_rank && project.project_rank != 'unknown'
        if (report.access_conversion_price * MasterProject.projectRanks[project.project_rank].goal) is 0
          report.goal_percentage = 0
        else
          report.goal_percentage = report.invoice_amount / (report.access_conversion_price * MasterProject.projectRanks[project.project_rank].goal) * 100

  MasterReportStats



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_report_stats.service.coffee